import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";

import history from '../../history';
import { fetchPrograms, createProgram , } from '../../actions/program';
import ProgramList from './ProgramList';


class Program extends React.Component {

  constructor(props) {
    super(props);
    const { fetchPrograms } = this.props;

    fetchPrograms();
    this.state = {
      programs : [],
      sortBy : 'alphabetic',
      user: JSON.parse(localStorage.getItem("user")),
    }
  }

  componentDidMount(){
    var _this = this

    if(this.props.programs.length){
      this.setState({
        programs:_this.props.programs
      })
    }
  }

  componentDidUpdate(prevProps,prevState){
    var _this = this
    if(!prevProps.programs.length && this.props.programs.length){
      this.setState({
        programs:_this.props.programs
      })
    }
    if(this.props.message === 'Program successfully removed!'){
      this.props.fetchPrograms();
    }
    if(this.props.message === 'Created Program' && this.props.program){
      history.push('/program/edit/'+this.props.program._id);
    }
  }


  renderPrograms() {
    if (this.state.programs && this.state.programs.length) {
      let programs = this.state.programs

      return (
        <ProgramList circle={false} items={programs} translate= {this.props.translate} endpoint= {"/program/"}/>
      );
    }
  }

  createProgram() {
    this.props.createProgram()
  }

  render() {


    const user = JSON.parse(localStorage.getItem("user"))
    

    return (
      <div>
        <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
        <div className="dashboard-header">
          <h1 className="page-title"><span style={{fontWeight: 'bold', color:'rgb(145, 179, 93)'}}>{this.state.programs.length}</span> Program(s) </h1>
          <div style={{"flexDirection":"row"}} >
            {
              user && (user.role === "Admin" || user.role === "SuperAdmin") ? <button className="primary-btn" style={{float:"left","marginRight":"20px"}} onClick={this.createProgram.bind(this)}>Add Program</button> : null
            }
            
          </div>  
        </div>
        {!this.state.programs || !this.state.programs.length ? (
          <div style={{left:'40%',right:'40%',top:'40%', bottom:'40%', display:'flex', position:'absolute', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <i className="fa fa-circle-notch fa-spin fa-3x" style={{color: '#eb4f1e'}}></i>
            <p style={{color:"#fff", marginTop:"10px", textAlign:'center'}}>Receiving programs ...</p>
          </div>
        ) : (
          <>
            <div className="tiles">
            </div>
            <div className="page-container">
              {this.renderPrograms()}
            </div>
          </>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    programs: state.program.programs,
    program: state.program.program,
    message: state.program.message,
  };
}

export default connect(mapStateToProps, {fetchPrograms, createProgram})(withLocalize(Program));
